<template lang="html">
  <form class="login" @submit.prevent="handleFormLogin">
    <div class="form-content">
      <div class="form-row inputs-with-hidden-labels">
        <label>
          <div class="label-text">Email address</div>
          <input
            v-model="email"
            v-focus="!email"
            name="email"
            type="text"
            autocomplete="username"
            placeholder="Email address"
            required
          />
        </label>

        <label>
          <div class="label-text">Password</div>
          <input
            v-model="password"
            v-focus="email"
            name="password"
            type="password"
            autocomplete="current-password"
            placeholder="Password"
            required
          />
        </label>
      </div>

      <LoadingButton
        class="form-row"
        button-text="Login"
        :is-loading="isLoading"
      />

      <ErrorList :errors="serverErrors" />

      <p class="form-row">
        <router-link :to="{ name: 'forgotPassword' }">
          Lost password?
        </router-link>
      </p>

      <p>
        New to <b>{{ appName }}</b
        >?
      </p>

      <router-link class="form-row" :to="{ name: 'join', query: $route.query }"
        >Signup</router-link
      >
    </div>
  </form>
</template>

<script>
import authenticationMixin from '@/mixins/authentication';
import { metaRobots } from '@/utils/meta';
import { appName, appDomain } from '@/constants';
import LoadingButton from '@/components/LoadingButton';

export default {
  name: 'Login',

  components: {
    LoadingButton,
  },

  mixins: [authenticationMixin],

  data() {
    return {
      appName,
      appDomain,
    };
  },

  metaInfo() {
    return {
      meta: [...metaRobots()],
    };
  },

  beforeMount() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }

    if (this.$route.query.account_confirmation_success) {
      this.$toasted.show(
        'Account confirmed! You can now log in with your email address.',
        { type: 'success' }
      );
    }
  },
};
</script>

<style scoped lang="scss">
.app-acronym {
  text-transform: uppercase;
}
</style>
